export const updateAgentEmployerFieldNumber = 256;

export const mapGetEmployerResponse = data => {
  return {
    ...data,
    agents: data.teams.flatMap(team =>
      team.agents.map(agent => ({
        ...agent,
        codePrefix: team.codePrefix,
      }))
    ),
  };
};
